import { render, staticRenderFns } from "./reciteInfo.vue?vue&type=template&id=52e50e0d"
import script from "./reciteInfo.vue?vue&type=script&lang=js"
export * from "./reciteInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports